/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2025 Open Assessment Technologies SA;
 */

import { __ } from '@oat-sa-private/ui-core';

export function cookiePolicyConfig() {
    return {
        title: __('Cookie Policy'),
        message: __(
            'This site uses cookies to improve your browsing experience and to perform analytics and research. To change your preferences, click Manage preferences. Otherwise, clicking Accept all cookies indicates you agree to our use of cookies on your device. Clicking Reject all cookies means you do not agree to our use of non-strictly necessary cookies on your device.'
        ),
        options: [
            {
                label: __('Essential Cookies'),
                value: 'essential',
                description: __(
                    'Strictly Necessary Cookie should be enabled at all times so that we can save your preferences for cookie settings.'
                ),
                required: true
            },
            {
                label: __('Analytics Cookies'),
                value: 'analytics',
                description: __(
                    'These cookies allow us to count visits and various other analytical data so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.'
                ),
                required: false
            }
        ],
        privacyPolicyLink: {
            label: __('Privacy Policy'),
            url: 'https://www.taotesting.com/about/privacy/'
        },
        cookiePolicyLink: {
            label: __('Cookie Policy'),
            url: 'https://www.taotesting.com/about/privacy/'
        }
    };
}
